<template>
  <div class="grid grid-cols-12 gap-4">
    <div class="col-span-12" v-if="document">
      <div class="grid grid-cols-12 gap-4" v-if="document.documentType === 'AGREEMENT' || document.documentType === 'CONSTITUTION' || document.documentType === 'MINUTES' || document.documentType === 'OTHERS' || document.documentType === 'RESOLUTION_AS_A_DOCUMENT'">
        <div class="col-span-12">
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <span class="h5">Parties</span>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <LegalPersonsPartner class="p-1" :individuals="document.individualParties" :corporates="document.entityParties"/>
            </div>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-12 gap-4" v-if=" document.documentType === 'GUARANTEE'">
        <div class="col-span-12">
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <span class="h5">Parties</span>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <LegalPersonsPartner class="p-1" :individuals="document.individualParties" :corporates="document.entityParties"/>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <span class="h5">Beneficiary</span>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <LegalPersonsPartner class="p-1" :individuals="document.individualBeneficiary"
                                   :corporates="document.entityBeneficiary" />
            </div>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-12 gap-4 mt-4" v-if="document.documentType === 'AFFIDAVIT' || document.documentType === 'STATUTORY_DECLARATION'">
        <div class="col-span-12">
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <span class="h5">Deponent's KYC</span>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <LegalPerson v-if="document.entityDeclarantDeponent != null" :person="document.entityDeclarantDeponent" entity-type="CORPORATE"/>
              <LegalPerson v-if="document.individualDeclarantDeponent != null" :person="document.individualDeclarantDeponent" entity-type="INDIVIDUAL"/>
            </div>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-12 gap-4" v-if="document.documentType === 'FACILITY_LETTER'">
        <div class="col-span-12">
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <div class="grid grid-cols-12 gap-4">
                <div class="col-span-4">
                  <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                    <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                      id="companyName"


  disabled="true"
                      :value="document.amountSecured.toLocaleString()"
                      required>
                    </input>
                  </div>
                </div>
                <div class="col-span-8">
                  <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                    <textarea
                      id="companyName"
                      class="form-text text-sm noFocus text-capitalize"
                      type="text"
                      disabled="true"
                      :value="document.collateral"
                      required>
                    </textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4 mt-2">
            <div class="col-span-12">
              <span class="h5">Borrowers</span>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <LegalPersonsPartner class="p-1" :individuals="document.individualBorrowers" :corporates="document.entityBorrowers"/>
            </div>
          </div>

          <div class="grid grid-cols-12 gap-4 mt-2">
            <div class="col-span-12">
              <span class="h5">Lenders</span>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <LegalPersonsPartner class="p-1" :individuals="document.individualLenders" :corporates="document.entityLenders"/>
            </div>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-12 gap-4" v-if="document.documentType === 'DEED_OF_ASSIGNMENT' || document.documentType === 'DEED_OF_INTER_VIVOS' || document.documentType ===  'DEED_OF_VARIATION' || document.documentType === 'DEED_OF_GIFT' || document.documentType === 'DEED_OF_INDEMNITY' || document.documentType === 'DEED_OF_TRUST'">
        <div class="col-span-12">
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <span class="h5">Assigners</span>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <LegalPersonsPartner class="p-1" :individuals="document.individualAssigners" :corporates="document.entityAssigners"/>
            </div>
          </div>

          <div class="grid grid-cols-12 gap-4 mt-2">
            <div class="col-span-12">
              <span class="h5">Assignees</span>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <LegalPersonsPartner class="p-1" :individuals="document.individualAssignees" :corporates="document.entityAssignees"/>
            </div>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-12 gap-4" v-if="document.documentType === 'DEED_POLL'">
        <div class="col-span-12">
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-4">
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                  id="companyName"


  disabled="true"
                  :value="document.oldName"
                  required>
                </input>
              </div>
            </div>
            <div class="col-span-4">
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                  id="companyName"


  disabled="true"
                  :value="document.newName"
                  required>
                </input>
              </div>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4 mt-2">
            <div class="col-span-12">
              <span class="h5">Address of Declarant</span>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4 mt-2">
            <div class="col-span-12">
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"


                  disabled="true"
                  :value="document.physicalAddress.district.name"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"


                  disabled="true"
                  :value="document.physicalAddress.region.name"
                  required>
                </input>
              </div>
            </div>
            <div class="col-span-12">
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"


                  disabled="true"
                  :value="document.physicalAddress.subcounty.name"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"


                  disabled="true"
                  :value="document.physicalAddress.parish.name"
                  required>
                </input>
              </div>
            </div>
            <div class="col-span-12">
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"


                  disabled="true"
                  :value="document.physicalAddress.village.name"
                  required>
                </input>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-12 gap-4" v-if="document.documentType === 'MORTGAGE_DEED'">
        <div class="col-span-12">
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <div class="grid grid-cols-12 gap-4">
                <div class="col-span-4">
                  <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                    <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                      id="companyName"


  disabled="true"
                      :value="document.amountSecured.toLocaleString()"
                      required>
                    </input>
                  </div>
                </div>
                <div class="col-span-4">
                  <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                    <textarea
                      id="companyName"
                      class="form-text text-sm noFocus text-capitalize"
                      type="text"
                      disabled="true"
                      :value="document.collateral"
                      required>
                    </textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4 mt-2">
            <div class="col-span-12">
              <span class="h5">Mortgagors</span>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <LegalPersonsPartner class="p-1" :individuals="document.individualMortgagors" :corporates="document.entityMortgagors"/>
            </div>
          </div>

          <div class="grid grid-cols-12 gap-4 mt-2">
            <div class="col-span-12">
              <span class="h5">Mortgagees</span>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <LegalPersonsPartner class="p-1" :individuals="document.individualMortgagees" :corporates="document.entityMortgagees"/>
            </div>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-12 gap-4 mt-4" v-if="document.documentType === 'POWER_OF_ATTORNEY'">
        <div class="col-span-12">
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <span class="h5">Donor KYC</span>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <LegalPerson v-if="document.entityDonor != null" :person="document.entityDonor" entity-type="CORPORATE"/>
              <LegalPerson v-if="document.individualDonor != null" :person="document.individualDonor" entity-type="INDIVIDUAL"/>
            </div>
          </div>

          <div class="grid grid-cols-12 gap-4 mt-2">
            <div class="col-span-12">
              <span class="h5">Donee KYC</span>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <LegalPerson v-if="document.entityDonee != null" :person="document.entityDonee" entity-type="CORPORATE"/>
              <LegalPerson v-if="document.individualDonee != null" :person="document.individualDonee" entity-type="INDIVIDUAL"/>
            </div>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-12 gap-4" v-if="document.documentType === 'SPOUSAL_CONSENT'">
        <div class="col-span-12">

          <div class="grid grid-cols-12 gap-4 mt-2">
            <div class="col-span-12">
              <span class="h5">Consenting Person</span>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <LegalPerson v-if="document.entityConsentingPerson != null" :person="document.entityConsentingPerson" entity-type="CORPORATE"/>
              <LegalPerson v-if="document.individualConsentingPerson != null" :person="document.individualConsentingPerson" entity-type="INDIVIDUAL"/>
            </div>
          </div>

          <div class="grid grid-cols-12 gap-4 mt-2">
            <div class="col-span-12">
              <span class="h5">Mortgagee</span>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <LegalPerson v-if="document.entityMortgagee != null" :person="document.entityMortgagee" entity-type="CORPORATE"/>
              <LegalPerson v-if="document.individualMortgagee != null" :person="document.individualMortgagee" entity-type="INDIVIDUAL"/>
            </div>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-12 gap-4" v-if="document.documentType === 'DEBENTURE'">
        <div class="col-span-12">
          <div class="grid grid-cols-12 gap-4 mt-2">
            <div class="col-span-12">
              <span class="h5">Assigners</span>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <LegalPersonsPartner class="p-1" :individuals="document.individualAssigners" :corporates="document.entityAssigners"/>
            </div>
          </div>

          <div class="grid grid-cols-12 gap-4 mt-2">
            <div class="col-span-12">
              <span class="h5">Assignees</span>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <LegalPersonsPartner class="p-1" :individuals="document.individualAssignees" :corporates="document.entityAssignees"/>
            </div>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-12 gap-4" v-if="document.documentType === 'CHATTEL'">
        <div class="col-span-12">
          <div class="grid grid-cols-12 gap-4 mt-2">
            <div class="col-span-12">
              <span class="h5">Assigners</span>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <LegalPersonsPartner class="p-1" :individuals="document.individualMortgagors" :corporates="document.entityMortgagors"/>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4 mt-2">
            <div class="col-span-12">
              <span class="h5">Assignees</span>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <LegalPersonsPartner class="p-1" :individuals="document.individualMortgagees" :corporates="document.entityMortgagees"/>
            </div>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-12 gap-4" v-if="document.documentType === 'DEMAND_PROMISSORY_NOTE'">
        <div class="col-span-12">
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-4">
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                  id="companyName"


  disabled="true"
                  :value="0"
                  required>
                </input>
              </div>
            </div>
            <div class="col-span-4">
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                  id="companyName"


  disabled="true"
                  :value="new Date()"
                  required>
                </input>
              </div>
            </div>
          </div>

          <div class="grid grid-cols-12 gap-4 mt-2">
            <div class="col-span-12">
              <span class="h5">Borrower KYC</span>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <LegalPerson v-if="document.entityBorrower != null" :person="document.entityBorrower" entity-type="CORPORATE"/>
              <LegalPerson v-if="document.individualBorrower != null" :person="document.individualBorrower" entity-type="INDIVIDUAL"/>
            </div>
          </div>

          <div class="grid grid-cols-12 gap-4 mt-2">
            <div class="col-span-12">
              <span class="h5">Creditor KYC</span>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <LegalPerson v-if="document.entityCreditor != null" :person="document.entityCreditor" entity-type="CORPORATE"/>
              <LegalPerson v-if="document.individualCreditor != null" :person="document.individualCreditor" entity-type="INDIVIDUAL"/>
            </div>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-12 gap-4 mt-4" v-if="document.documentType === 'INDEPENDENT_ADVISE_FORM'">
        <div class="col-span-12">
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <span class="h5">Advisor KYC</span>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <LegalPerson v-if="document.entityAdviser != null" :person="document.entityAdviser" entity-type="CORPORATE"/>
              <LegalPerson v-if="document.individualAdviser != null" :person="document.individualAdviser" entity-type="INDIVIDUAL"/>
            </div>
          </div>

          <div class="grid grid-cols-12 gap-4 mt-2">
            <div class="col-span-12">
              <span class="h5">Advisee KYC</span>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <LegalPerson v-if="document.entityAdvise != null" :person="document.entityAdvise" entity-type="CORPORATE"/>
              <LegalPerson v-if="document.individualAdvise != null" :person="document.individualAdvise" entity-type="INDIVIDUAL"/>
            </div>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-12 gap-4" v-if="document.documentType === 'REPORT_OF_DIRECTORS'">
        <div class="col-span-12">
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <div class="grid grid-cols-12 gap-4">
                <div class="col-span-4">
                  <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                    <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                      id="companyName"


  disabled="true"
                      :value="document.amountSecured.toLocaleString()"
                      required>
                    </input>
                  </div>
                </div>
                <div class="col-span-4">
                  <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                    <textarea
                      id="companyName"
                      class="form-text text-sm noFocus text-capitalize"
                      type="text"
                      disabled="true"
                      :value="document.collateral"
                      required>
                    </textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4 mt-2">
            <div class="col-span-12">
              <span class="h5">Mortgagors</span>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <LegalPersonsPartner class="p-1" :individuals="document.individualMortgagors" :corporates="document.entityMortgagors"/>
            </div>
          </div>

          <div class="grid grid-cols-12 gap-4 mt-2">
            <div class="col-span-12">
              <span class="h5">Mortgagees</span>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <LegalPersonsPartner class="p-1" :individuals="document.individualMortgagees" :corporates="document.entityMortgagees"/>
            </div>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-12 gap-4" v-if="document.documentType === 'WILL'">
        <div class="col-span-12">
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <div class="grid grid-cols-12 gap-4">
                <div class="col-span-4">
                  <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                    <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                      id="companyName"


  disabled="true"
                      :value="document.amountSecured.toLocaleString()"
                      required>
                    </input>
                  </div>
                </div>
                <div class="col-span-4">
                  <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                    <textarea
                      id="companyName"
                      class="form-text text-sm noFocus text-capitalize"
                      type="text"
                      disabled="true"
                      :value="document.collateral"
                      required>
                    </textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4 mt-2">
            <div class="col-span-12">
              <span class="h5">Mortgagors</span>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <LegalPersonsPartner class="p-1" :individuals="document.individualMortgagors" :corporates="document.entityMortgagors"/>
            </div>
          </div>

          <div class="grid grid-cols-12 gap-4 mt-2">
            <div class="col-span-12">
              <span class="h5">Mortgagees</span>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <LegalPersonsPartner class="p-1" :individuals="document.individualMortgagees" :corporates="document.entityMortgagees"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import LegalPersonsPartner from "@/domains/home/services/registry/legal-documents/LegalPersonsPartner.vue";
import LegalPerson from "@/domains/home/services/registry/legal-documents/LegalPerson.vue";
import { type PropType } from "vue";
import { LegalDocument } from "@/domains/home/services/registry/legal-documents/types";

defineProps({
  document: Object as PropType<LegalDocument>
});
</script>
